import { useState } from 'react';
import { useTranslations } from 'next-intl';
import Button from '@monofront/design-system/components/Button';
import Modal from '@monofront/design-system/organisms/Modal';
import {
  AddToShoppingCartContext,
  AddToShoppingCartSource,
  ISearchProduct,
  IShoppingCartProductBundleInfo,
} from '@monofront/types';
import useProductBasketToShoppingCart from '@hooks/cart/useProductBasketToShoppingCart';
import ButtonCounter from '@components/ButtonCounter';
import Cart from '@monofront/design-system/visuals/Icons/Cart';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';

interface IButtonAddBasketToCartProps {
  products: ISearchProduct[];
  hasEditViewOnly: boolean;
  bundleInfos: IShoppingCartProductBundleInfo;
  containerContext?: AddToShoppingCartContext;
}

const ButtonAddBasketToCart: React.FC<IButtonAddBasketToCartProps> = ({
  products,
  hasEditViewOnly,
  bundleInfos,
  containerContext = { source: AddToShoppingCartSource.BUNDLE },
}) => {
  const { currentProductQuantity, editShoppingCart, hasProductsNotAvailable } =
    useProductBasketToShoppingCart(products, bundleInfos, containerContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const tCatalog = useTranslations('Catalog');
  const tGlobal = useTranslations('Global');

  return (
    <>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          externalToggle={() => setIsModalOpen(false)}
          UNSAFE_className="modal-button-basket"
          hasPadding
        >
          <p>
            {tCatalog.rich('basketOutOfStock', {
              span: (children) => (
                <span role="img" aria-label="sniff">
                  {children}
                </span>
              ),
            })}
            {tCatalog('basketOutOfStockCTA')}
          </p>
          <div className="modal-cta">
            <Button
              variant="primary"
              onClick={() => setIsModalOpen(false)}
              dataTestId="ButtonAddBasketToCart-Button-1"
            >
              {tGlobal('ok')}
            </Button>
          </div>
        </Modal>
      )}
      <ButtonCounter
        currentQuantity={currentProductQuantity}
        editCount={editShoppingCart}
        hasEditViewOnly={hasEditViewOnly}
      >
        <span
          className="icon"
          onClick={() => {
            if (hasProductsNotAvailable) {
              setIsModalOpen(true);

              return;
            }
          }}
        >
          <Cart size={IconSizes.lg} aria-hidden focusable={false} />
        </span>
      </ButtonCounter>
      <style jsx>{`
        :global(.modal-button-basket) {
          top: 33%;
          max-width: 550px;
        }

        .modal-cta {
          margin-top: var(--space-5);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-cta > :global(button:first-child) {
          margin-right: var(--space-3);
        }
      `}</style>
    </>
  );
};

export default ButtonAddBasketToCart;
